<template>
 <d-row>
      <d-col lg="8">
  <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
    <i class="fa fa-info mx-2"></i>
    <span id="warning">{{ error_msg }}</span> 
  </d-alert>

  <d-card class="card-small mb-4">
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
    <!-- Card Header -->
    <d-card-header class="border-bottom">
       <d-button type="button" :disabled="loading" class="btn-accent" @click="save_form" data-toggle="tooltip" data-placement="top" title="Save Form" ><i class="material-icons">save_alt</i> Save</d-button>&nbsp;
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>

                <!-- RFID -->
                <d-col md="6" :class="{ 'form-group--error' : $v.rfid.$error }">
                  <label for="feRFID">RFID</label>
                  <d-form-input type="text" id="rfid" placeholder="RFID" v-model.trim="$v.rfid.$model" />
                  <div  class="verror" v-if="!loading && !$v.rfid.required">Harap isi kolom ini</div>
                </d-col>

                <!-- status -->
                <d-col md="6" :class="{ 'form-group--error' : $v.status.$error }">
                  <label for="feStatus">Status</label>
                  <d-form-select v-model="status" :options="statuses" style="padding-left:1px" />
                  <div  class="verror" v-if="!loading && !$v.status.required">Harap isi kolom ini</div>
                </d-col>

              </d-form-row>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
      </d-col>
 </d-row>
</template>
<style>
.item {
  display: flex;
  align-items: center;
}

.item-name {
  font-size: 12px;
}
</style>
<script>
import VueElementLoading from 'vue-element-loading';
import env from '../../env.vue';
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    VueElementLoading,
  },
  name: 'card-info',
  data(){
    return {
      form:'',
      id:'',
      number:'',
      rfid:'',
      loading:false,
      status:'1',
      old_data:[],
      error_msg:'',
      show_alert:false,
      statuses:[
       { value: '1', text:'Aktif' },
       { value: '0', text:'Hilang' },
      ],
    }
  },
  validations:{
    rfid:{ required },
    status:{ required },
  },
  watch: {
    '$route.query.id'(newId,oldId){
      if (newId!=oldId){
        if ( newId==0 ) this.resetForm();
      }
    },
  },
  methods: {
    save_form(){
        let dthis=this;        
        let submit=true;
        if (submit){
          this.loading=true;
          this.axios.post( env.server+'/card/save/'+this.id,
          {
            rfid:this.rfid,
            status:this.status,
          }).then( resp=>{
            this.loading=false;
            this.$buefy.toast.open({ message:'Data sudah disimpan',
              position: 'is-bottom',
              type: 'is-success',
            });
          }).catch(e=>{
            if (e.response.status==500)
              this.pop_alert(JSON.parse(e.response.data).message);
            this.loading=false;
          })
        }
    },
    pop_alert(msg){
      if (msg==undefined) return;
      this.$refs.dalert.dismissed=false;
      this.show_alert=10;
      this.error_msg=msg;
    },
    resetForm(){
      var dthis=this;
      this.old_data={ 
      rfid:'',
      status:'',
      }
      Object.keys(this.old_data).forEach( key=>{
        eval('dthis.'+key+'=\'\'');
      });        
    }
  },
  mounted(){
    this.id=this.$route.query.id;
    if ( this.id>0 ){
      this.loading=true;
      this.axios.get( env.server+'/card/load/'+this.id).then(
        resp=>{
          resp.data = JSON.parse(resp.data);
          resp.data = resp.data.data;
          this.rfid=resp.data.rfid;
          this.status=resp.data.status;
          this.loading=false;
          }
      )
    } else {
      this.resetForm()
      this.status="1" ; 
    }
  },
};
</script>
